import { dateformat } from '../../helpers';
import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_ACCESOS = 'ALL_ACCESOS';
export const ACTIVO_ACCESOS = 'ACTIVO_ACCESOS';
export const LOADING_ALL_ACCESOS = 'LOADING_ALL_ACCESOS';
export const PARAMS_ACCESOS = 'PARAMS_ACCESOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
  params: {
    entrada: dateformat(null, {}),
    salida: dateformat(null, {}),
    page: 1,
    limit: 50,
  },
};

export const accesosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ACCESOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_ACCESOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_ACCESOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_ACCESOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
